import { useNavigate } from 'react-router';

import { runSearch } from '.';

export const useRunSearch = () => {
  const navigate = useNavigate();
  return (props: Omit<typeof runSearch, 'navigate'>) =>
    runSearch({ ...props, navigate });
};
